import { useState, useEffect } from 'react';
import { select } from "d3-selection";

import ReactWordcloud from 'react-wordcloud';
import Info from '../Info';

function DashboardCloudCard({data, title, hint, keywordClicked}) {

  const callbacks = {
    //getWordColor: word => word.value > 50 ? "blue" : "red",
    onWordClick: getCallback("onWordClick"),
    onWordMouseOut: getCallback("onWordMouseOut"),
    onWordMouseOver: getCallback("onWordMouseOver"),
    getWordTooltip: word => ''
  }
  const [ words, setWords ] = useState([])

  function getCallback(callback) {
    return function (word, event) {
      const isActive = callback !== "onWordMouseOut";
      const element = event.target;
      const text = select(element);
      text
        .on("click", () => {
          if (isActive) {
            keywordClicked(word.text)
          }
        })
        .attr("background", "white")
        .attr("font-size", isActive ? "150%" : "100%")
        .attr("font-weight", isActive ? "bold" : "none");
    };
  }

  const options = {
    fontWeight: 500,
    fontFamily: 'Inter, sans-serif',
    fontSizes: [10, 50],
    enableOptimizations: true
  };

  useEffect(() => {
    if(data!=null)
      setWords(data)
  }, [data]);

  return (
    <div className="flex flex-col col-span-full sm:col-span-6 xl:col-span-6 bg-white shadow-1 rounded-sm border border-gray-200">
      <header className="px-5 py-4 border-b border-gray-100 flex items-center">
        <h2 className="font-semibold text-gray-800">{title}</h2>
        <Info className="ml-2" containerClassName="min-w-80">
          <div className="text-sm">{hint}</div>
        </Info>
      </header>
      {/* Chart built with Chart.js 3 */}
      {/* Change the height attribute to adjust the chart height */}
      <div className="h-64 h-full">
        {words.length>0?<ReactWordcloud words={words} options={options} callbacks={callbacks}/>:
          <div className="sm:flex justify-items-center mt-5 w-full mb-5">
            <div className="m-auto text-center">
              <svg className="animate-spin h-8 w-full mb-2" viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="10" fill="transparent" strokeLinecap="round"
                        strokeDasharray="283" strokeDashoffset="75"/>
              </svg>
              <p className="w-full">
                Loading word cloud...
              </p>
            </div>
          </div>
        }
      </div>
    </div>
  );
}

export default DashboardCloudCard;
